<template>
  <div :class="classObj" class="app-wrapper">
    <template v-if="$route.meta.noNavBar || hideBpmNav">
      <headerbar v-if="showNav" />
      <app-main />
    </template>
    <template v-else>
      <!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
      <sidebar v-if="showNav" class="sidebar-container" />
      <headerbar v-if="showNav" />
      <div :class="{hasTagsView:needTagsView}" class="main-container">
        <div v-if="showNav" :class="{'fixed-header':fixedHeader}">
          <navbar />
        </div>
        <app-main />
      </div>
    </template>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, Headerbar } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    Headerbar
  },
  mixins: [ResizeMixin],
  data() {
    return {
      hideBpmNav: sessionStorage.getItem('hideBpmNav')
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      inFrame: state => state.app.inFrame
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        inFrame: this.inFrame
        // mobile: this.device === 'mobile'
      }
    },
    showNav() {
      return !this.inFrame && !sessionStorage.getItem('hideBpmNav')
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
